var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "78px",
    viewBox: "0 0 88 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5B167F45-BAAB-49A2-BD7F-B6AFCCE9CCDC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popups",
    transform: "translate(-326.000000, -132.000000)",
    fill: "#FFB274",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.999914,132 C373.740934,132 377.09094,133.910904 378.961278,137.111252 L378.961278,137.111252 L412.597117,194.666243 C414.467628,197.866761 414.467628,201.68823 412.597117,204.888917 C410.726435,208.089096 407.37643,210 403.635581,210 L403.635581,210 L336.364247,210 C332.623227,210 329.273393,208.089266 327.402883,204.888748 C325.532372,201.68823 325.532372,197.866761 327.402883,194.666073 L327.402883,194.666073 L361.03855,137.111252 C362.908888,133.910904 366.259066,132 369.999914,132 Z M370.000086,137.093424 C368.123045,137.093424 366.442112,138.052102 365.503677,139.658049 L365.503677,139.658049 L331.867666,197.21304 C330.929232,198.818987 330.929232,200.736343 331.867666,202.342291 C332.806101,203.948238 334.487034,204.906916 336.364247,204.906916 L336.364247,204.906916 L403.635581,204.906916 C405.512623,204.906916 407.193555,203.948238 408.132162,202.342291 C409.070596,200.736343 409.070596,198.818987 408.132334,197.21304 L408.132334,197.21304 L374.496495,139.658049 C373.55806,138.052102 371.876955,137.093424 370.000086,137.093424 Z M370,188 C371.654215,188 373,189.345785 373,191 C373,192.654215 371.654065,194 370,194 C368.345785,194 367,192.654215 367,191 C367,189.345785 368.345785,188 370,188 Z M373,158 L373,183 L367,183 L367,158 L373,158 Z",
    id: "attention"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.989d0e0e.svg";
export { ForwardRef as ReactComponent };